import React, { useState, useEffect, useCallback, useMemo, useRef } from 'react';
import './ScrollingLogos.css';

// --- Constantes de configuration ---
const LOGO_SLOT_WIDTH = 120;
const LOGO_ITEM_HEIGHT = 48;
const SCROLL_SPEED_PPS = 50;
const MANUAL_SCROLL_TRANSITION_DURATION_S = 0.5;
const MIN_SWIPE_THRESHOLD = 40;
const AUTO_STEP_INTERVAL_MS = 2500;

const defaultLogos = [
  { src: '/images/logos/js.png', alt: 'Logo JavaScript' },
  { src: '/images/logos/flutter1.png', alt: 'Logo Flutter' },
  { src: '/images/logos/supabase.png', alt: 'Logo Supabase' },
  { src: '/images/logos/ps.png', alt: 'Logo Adobe Photoshop' },
  { src: '/images/logos/figma1.png', alt: 'Logo Figma' },
  { src: '/images/logos/next.png', alt: 'Logo Next.js' },
  { src: '/images/logos/angular.png', alt: 'Logo Angular' },
  { src: '/images/logos/nest1.png', alt: 'Logo NestJS' },
  { src: '/images/logos/spring.png', alt: 'Logo Spring Framework' },
  { src: '/images/logos/apollo.png', alt: 'Logo Apollo' },
  { src: '/images/logos/ubuntu1.png', alt: 'Logo Ubuntu' },
  { src: '/images/logos/microsoft1.png', alt: 'Logo Microsoft' },
  { src: '/images/logos/css.png', alt: 'Logo CSS' },
  { src: '/images/logos/react1.png', alt: 'Logo React' },
  { src: '/images/logos/ruby.png', alt: 'Logo Ruby' },
  { src: '/images/logos/js4.png', alt: 'Logo JavaScript' },
  { src: '/images/logos/adobe.png', alt: 'Logo Adobe' },
  { src: '/images/logos/office1.png', alt: 'Logo Microsoft Office' },
  { src: '/images/logos/pr.png', alt: 'Logo Adobe Premiere Pro' },
  { src: '/images/logos/apple1.png', alt: 'Logo Apple' },
  { src: '/images/logos/js2.png', alt: 'Logo JavaScript' },
  { src: '/images/logos/firebase1.png', alt: 'Logo Firebase' },
  { src: '/images/logos/google.png', alt: 'Logo Google' },
  { src: '/images/logos/webpack.png', alt: 'Logo Webpack' },
  { src: '/images/logos/next1.jpg', alt: 'Logo Next.js' },
  { src: '/images/logos/css1.png', alt: 'Logo CSS' },
  { src: '/images/logos/postgres.png', alt: 'Logo PostgreSQL' },
  { src: '/images/logos/safe.png', alt: 'Logo Safe' },
  { src: '/images/logos/unity.png', alt: 'Logo Unity' },
  { src: '/images/logos/ios.png', alt: 'Logo iOS' },
  { src: '/images/logos/wordpress1.png', alt: 'Logo WordPress' },
  { src: '/images/logos/java5.png', alt: 'Logo Java' },
  { src: '/images/logos/vite.png', alt: 'Logo Vite' },
  { src: '/images/logos/git.png', alt: 'Logo Git' },
  { src: '/images/logos/html3.png', alt: 'Logo HTML5' },
  { src: '/images/logos/graphql3.png', alt: 'Logo GraphQL' },
  { src: '/images/logos/dart.png', alt: 'Logo Dart' },
  { src: '/images/logos/node.png', alt: 'Logo Node.js' },
  { src: '/images/logos/react.png', alt: 'Logo React' },
  { src: '/images/logos/c.png', alt: 'Logo C' },
  { src: '/images/logos/linux1.png', alt: 'Logo Linux' },
  { src: '/images/logos/ts1.png', alt: 'Logo TypeScript' },
  { src: '/images/logos/android1.png', alt: 'Logo Android' },
  { src: '/images/logos/chakraui.png', alt: 'Logo Chakra UI' },
  { src: '/images/logos/github.png', alt: 'Logo GitHub' },
  { src: '/images/logos/html2.png', alt: 'Logo HTML5' },
  { src: '/images/logos/ionic.png', alt: 'Logo Ionic' },
  { src: '/images/logos/mysql.png', alt: 'Logo MySQL' },
  { src: '/images/logos/js1.png', alt: 'Logo JavaScript' },
  { src: '/images/logos/ts.png', alt: 'Logo TypeScript' },
  { src: '/images/logos/fastify.png', alt: 'Logo Fastify' },
  { src: '/images/logos/html.png', alt: 'Logo HTML5' },
  { src: '/images/logos/redis.png', alt: 'Logo Redis' },
  { src: '/images/logos/supabase1.png', alt: 'Logo Supabase' },
  { src: '/images/logos/mongo.png', alt: 'Logo MongoDB' },
  { src: '/images/logos/flutter.png', alt: 'Logo Flutter' },
  { src: '/images/logos/java1.png', alt: 'Logo Java' },
  { src: '/images/logos/apple2.png', alt: 'Logo Apple' },
  { src: '/images/logos/spring1.png', alt: 'Logo Spring Framework' },
  { src: '/images/logos/vu.png', alt: 'Logo Vue.js' },
  { src: '/images/logos/graphql.png', alt: 'Logo GraphQL' },
  { src: '/images/logos/facebook.png', alt: 'Logo Facebook' },
  { src: '/images/logos/firebase.png', alt: 'Logo Firebase' },
  { src: '/images/logos/ubuntu.png', alt: 'Logo Ubuntu' },
  { src: '/images/logos/linux.png', alt: 'Logo Linux' },
  { src: '/images/logos/python2.png', alt: 'Logo Python' },
  { src: '/images/logos/postgres2.png', alt: 'Logo PostgreSQL' },
  { src: '/images/logos/java.png', alt: 'Logo Java' },
  { src: '/images/logos/unity1.png', alt: 'Logo Unity' },
  { src: '/images/logos/nest.png', alt: 'Logo NestJS' },
  { src: '/images/logos/sqlite.png', alt: 'Logo SQLite' },
  { src: '/images/logos/angular1.png', alt: 'Logo Angular' },
  { src: '/images/logos/office.png', alt: 'Logo Microsoft Office' },
  { src: '/images/logos/ts2.png', alt: 'Logo TypeScript' },
  { src: '/images/logos/ui.png', alt: 'Logo UI Design' },
  { src: '/images/logos/ionic1.png', alt: 'Logo Ionic' },
  { src: '/images/logos/microsoft.png', alt: 'Logo Microsoft' },
  { src: '/images/logos/ubuntu2.png', alt: 'Logo Ubuntu' },
  { src: '/images/logos/bootstrap1.png', alt: 'Logo Bootstrap' },
  { src: '/images/logos/git1.png', alt: 'Logo Git' }
];

function ScrollingLogos({ logos = defaultLogos }) {
  const [currentTranslateX, setCurrentTranslateX] = useState(0);
  const trackRef = useRef(null);
  const viewportRef = useRef(null);
  const animationFrameRef = useRef(null);
  const lastTimestampRef = useRef(null);
  const autoStepTimerRef = useRef(null);

  const isManuallyInteractingRef = useRef(false);
  const isJumpingRef = useRef(false);
  const [isHoverPaused, setIsHoverPaused] = useState(false);
  const isMouseOverContainerRef = useRef(false);

  const touchStartXRef = useRef(0);
  const touchStartYRef = useRef(0);

  const isDraggingRef = useRef(false);
  const dragStartClientXRef = useRef(0);
  const dragInitialTranslateXRef = useRef(0);
  const originalBodyUserSelectRef = useRef('');

  const originalLogosCount = useMemo(() => (logos ? logos.length : 0), [logos]);

  const extendedLogos = useMemo(() => {
    if (!logos || originalLogosCount === 0) return [];
    const doubled = [...logos, ...logos];
    return doubled.map((logo, idx) => ({ ...logo, uniqueId: `${logo.alt || 'logo'}-d-${idx}` }));
  }, [logos, originalLogosCount]);

  const startingPointInExtendedListIndex = useMemo(() => {
    return 0;
  }, [originalLogosCount, extendedLogos]);

  useEffect(() => {
    if (originalLogosCount > 0 && extendedLogos.length > 0) {
      const initialX = -(startingPointInExtendedListIndex * LOGO_SLOT_WIDTH);
      isJumpingRef.current = true;
      setCurrentTranslateX(initialX);
      if (trackRef.current) void trackRef.current.offsetHeight;
      isJumpingRef.current = false;
    }
  }, [startingPointInExtendedListIndex, originalLogosCount, extendedLogos.length]);

  const stopContinuousScroll = useCallback(() => {
    if (animationFrameRef.current) {
      cancelAnimationFrame(animationFrameRef.current);
      animationFrameRef.current = null;
    }
    lastTimestampRef.current = null;
  }, []);

  const continuousScrollStep = useCallback((timestamp) => {
    animationFrameRef.current = null;
    lastTimestampRef.current = null;
    return;

    if (isManuallyInteractingRef.current || isJumpingRef.current || isMouseOverContainerRef.current || isDraggingRef.current || originalLogosCount === 0) {
      lastTimestampRef.current = null;
      animationFrameRef.current = requestAnimationFrame(continuousScrollStep);
      return;
    }

    if (!lastTimestampRef.current) {
      lastTimestampRef.current = timestamp;
      animationFrameRef.current = requestAnimationFrame(continuousScrollStep);
      return;
    }
    const deltaTimeMs = timestamp - lastTimestampRef.current;
    lastTimestampRef.current = timestamp;
    const pixelsToScroll = SCROLL_SPEED_PPS * (deltaTimeMs / 1000);
    setCurrentTranslateX(prevX => {
      let newX = prevX - pixelsToScroll;
      const cycleWidth = originalLogosCount * LOGO_SLOT_WIDTH;
      const logicalStartOfCentralBlockX = -(startingPointInExtendedListIndex * LOGO_SLOT_WIDTH);
      const logicalEndOfCentralBlockX = -((startingPointInExtendedListIndex + originalLogosCount) * LOGO_SLOT_WIDTH);
      if (newX <= logicalEndOfCentralBlockX) newX += cycleWidth;
      else if (newX > logicalStartOfCentralBlockX) newX -= cycleWidth;
      return newX;
    });
    animationFrameRef.current = requestAnimationFrame(continuousScrollStep);
  }, [originalLogosCount, startingPointInExtendedListIndex]);

  const startContinuousScroll = useCallback(() => {
    return;
  }, [continuousScrollStep, originalLogosCount, stopContinuousScroll]);

  useEffect(() => {
    return stopContinuousScroll;
  }, [isHoverPaused, originalLogosCount, startContinuousScroll, stopContinuousScroll]);

  const performScrollAndLoopIfNeeded = useCallback((targetTranslateX) => {
    isManuallyInteractingRef.current = true;
    setCurrentTranslateX(targetTranslateX); // Déclenche la transition CSS (snap/settle)

    const transitionEndTime = MANUAL_SCROLL_TRANSITION_DURATION_S * 1000;
    const timer = setTimeout(() => {
      let finalTranslateXAfterLogic = targetTranslateX;

      if (originalLogosCount > 0) {
        const cycleWidth = originalLogosCount * LOGO_SLOT_WIDTH;
        while (finalTranslateXAfterLogic <= -cycleWidth) finalTranslateXAfterLogic += cycleWidth;
        while (finalTranslateXAfterLogic > 0) finalTranslateXAfterLogic -= cycleWidth;
      }

      isJumpingRef.current = true;
      setCurrentTranslateX(finalTranslateXAfterLogic);
      if (trackRef.current) void trackRef.current.offsetHeight; // Forcer le reflow pour appliquer le changement
      isJumpingRef.current = false;

      isManuallyInteractingRef.current = false;
      if (!isMouseOverContainerRef.current && !isDraggingRef.current) {
        startContinuousScroll();
      }
    }, transitionEndTime + 50); // Le +50ms est un petit buffer
    return () => clearTimeout(timer);
  }, [originalLogosCount, startingPointInExtendedListIndex, startContinuousScroll]);

  const dragMoveHandler = useCallback((e) => {
    if (!isDraggingRef.current || !trackRef.current) return;
    if (e.cancelable) e.preventDefault();
    const clientX = e.type === 'touchmove' ? e.touches[0].clientX : e.clientX;
    const walk = clientX - dragStartClientXRef.current;
    const newTranslateX = dragInitialTranslateXRef.current + walk;
    trackRef.current.style.transform = `translateX(${newTranslateX}px)`;
  }, []);

  const dragEndHandler = useCallback(() => {
    if (!isDraggingRef.current || !trackRef.current) return;
    isDraggingRef.current = false;
    document.body.style.userSelect = originalBodyUserSelectRef.current;
    if (viewportRef.current) {
      viewportRef.current.style.cursor = 'grab';
    }
    document.removeEventListener('mousemove', dragMoveHandler);
    document.removeEventListener('mouseup', dragEndHandler);
    document.removeEventListener('touchmove', dragMoveHandler);
    document.removeEventListener('touchend', dragEndHandler);

    const style = window.getComputedStyle(trackRef.current);
    const matrix = new DOMMatrixReadOnly(style.transform);
    const finalTranslateX = matrix.m41; // Position exacte où le drag s'est terminé

    if (trackRef.current) trackRef.current.style.transition = ''; // Permet à trackTransitionStyle de s'appliquer pour le snap

    performScrollAndLoopIfNeeded(finalTranslateX);
  }, [dragMoveHandler, performScrollAndLoopIfNeeded]);

  const dragStartHandler = useCallback((e) => {
    if (originalLogosCount === 0 || !trackRef.current || !viewportRef.current) return;
    if (e.type === 'touchstart') {
      e.stopPropagation();
      if (e.cancelable) e.preventDefault();
    } else if (e.type === 'mousedown') {
      if (e.button !== 0) return;
      if (e.cancelable) e.preventDefault();
    }
    isDraggingRef.current = true;
    isManuallyInteractingRef.current = true;
    stopContinuousScroll();
    originalBodyUserSelectRef.current = document.body.style.userSelect;
    document.body.style.userSelect = 'none';
    dragStartClientXRef.current = e.type === 'touchstart' ? e.touches[0].clientX : e.clientX;
    const style = window.getComputedStyle(trackRef.current);
    const matrix = new DOMMatrixReadOnly(style.transform);
    dragInitialTranslateXRef.current = matrix.m41;
    if (trackRef.current) trackRef.current.style.transition = 'none'; // Pas de transition CSS pendant le drag
    if (viewportRef.current) viewportRef.current.style.cursor = 'grabbing';
    document.addEventListener('mousemove', dragMoveHandler, { passive: false });
    document.addEventListener('mouseup', dragEndHandler);
    document.addEventListener('touchmove', dragMoveHandler, { passive: false });
    document.addEventListener('touchend', dragEndHandler);
  }, [originalLogosCount, stopContinuousScroll, dragMoveHandler, dragEndHandler]);

  const handleManualNavigation = useCallback((direction) => {
    if (isManuallyInteractingRef.current || originalLogosCount === 0) return;
    let currentX = 0; // Default to 0, will be overridden
    if (trackRef.current) { // Lire la position actuelle du DOM
      const style = window.getComputedStyle(trackRef.current);
      const matrix = new DOMMatrixReadOnly(style.transform);
      currentX = matrix.m41;
    } else { // Fallback (moins précis si une anim était en cours)
      currentX = currentTranslateX;
    }
    const newTranslateX = currentX - (direction * LOGO_SLOT_WIDTH);
    performScrollAndLoopIfNeeded(newTranslateX);
  }, [currentTranslateX, performScrollAndLoopIfNeeded, originalLogosCount]); // currentTranslateX pour le fallback

  const handleNext = useCallback(() => handleManualNavigation(1), [handleManualNavigation]);
  const handlePrev = useCallback(() => handleManualNavigation(-1), [handleManualNavigation]);

  const handleWrapperTouchStart = useCallback((e) => {
    if (originalLogosCount === 0 || isDraggingRef.current) return;
    touchStartXRef.current = e.touches[0].clientX;
    touchStartYRef.current = e.touches[0].clientY;
  }, [originalLogosCount]);

  const handleWrapperTouchMove = useCallback((e) => {
    if (!touchStartXRef.current || !touchStartYRef.current || originalLogosCount === 0 || isDraggingRef.current) return;
    const currentX = e.touches[0].clientX;
    const currentY = e.touches[0].clientY;
    if (Math.abs(currentX - touchStartXRef.current) > Math.abs(currentY - touchStartYRef.current)) {
      if (e.cancelable) e.preventDefault();
    }
  }, [originalLogosCount]);

  const handleWrapperTouchEnd = useCallback((e) => {
    if (!touchStartXRef.current || originalLogosCount === 0 || isDraggingRef.current) return;
    const touchEndX = e.changedTouches[0].clientX;
    const swipeDelta = touchStartXRef.current - touchEndX;
    if (Math.abs(swipeDelta) > MIN_SWIPE_THRESHOLD) {
      handleManualNavigation(swipeDelta > 0 ? 1 : -1);
    } else {
      // Pas de redémarrage RAF en mode "par pas"
    }
    touchStartXRef.current = 0;
    touchStartYRef.current = 0;
  }, [handleManualNavigation, startContinuousScroll, originalLogosCount]);

  const handleMouseEnter = useCallback(() => {
    if (originalLogosCount > 0) {
      isMouseOverContainerRef.current = true;
      setIsHoverPaused(true);
    }
  }, [originalLogosCount]);

  const handleMouseLeave = useCallback(() => {
    if (originalLogosCount > 0) {
      isMouseOverContainerRef.current = false;
      setIsHoverPaused(false);
    }
  }, [originalLogosCount]);

  useEffect(() => {
    if (originalLogosCount === 0) return;
    if (autoStepTimerRef.current) return;

    autoStepTimerRef.current = setInterval(() => {
      if (isMouseOverContainerRef.current) return;
      if (isDraggingRef.current) return;
      if (isManuallyInteractingRef.current) return;
      handleNext();
    }, AUTO_STEP_INTERVAL_MS);

    return () => {
      if (autoStepTimerRef.current) {
        clearInterval(autoStepTimerRef.current);
        autoStepTimerRef.current = null;
      }
    };
  }, [handleNext, originalLogosCount]);

  let trackTransitionStyle = 'none';
  if (isManuallyInteractingRef.current && !isJumpingRef.current && !isDraggingRef.current) {
    trackTransitionStyle = `transform ${MANUAL_SCROLL_TRANSITION_DURATION_S}s ease-out`;
  }
  const trackStyle = {
    width: `${extendedLogos.length * LOGO_SLOT_WIDTH}px`,
    transform: `translateX(${currentTranslateX}px)`,
    transition: trackTransitionStyle,
  };

  return (
    <div
      className="scrolling-logos-container"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onTouchStart={handleWrapperTouchStart}
      onTouchMove={handleWrapperTouchMove}
      onTouchEnd={handleWrapperTouchEnd}
      aria-label="Bandeau des technologies et partenaires que nous utilisons"
    >
      {originalLogosCount > 0 && (
        <>
          <button type="button" className="carousel-arrow prev-arrow" onClick={handlePrev} aria-label="Logos précédents">&#10094;</button>
          <div
            ref={viewportRef}
            className="logos-viewport"
            onMouseDown={dragStartHandler}
            onTouchStart={dragStartHandler}
          >
            <div ref={trackRef} className="logos-track" style={trackStyle}>
              {extendedLogos.map((logo) => (
                <div
                  className="logo-item"
                  key={logo.uniqueId}
                  style={{ width: `${LOGO_SLOT_WIDTH}px`, height: `${LOGO_ITEM_HEIGHT}px` }}
                >
                  <img src={logo.src} alt={logo.alt || `Logo Partenaire`} />
                </div>
              ))}
            </div>
          </div>
          <button type="button" className="carousel-arrow next-arrow" onClick={handleNext} aria-label="Logos suivants">&#10095;</button>
        </>
      )}
      {originalLogosCount === 0 && <p className="no-logos-message">Aucun logo à afficher.</p>}
    </div>
  );
}

export default ScrollingLogos;